export var ApplicationsEnum; (function (ApplicationsEnum) {
  const GO = 'go-applicattion'; ApplicationsEnum["GO"] = GO;
  const PYTHON = 'python-application'; ApplicationsEnum["PYTHON"] = PYTHON;
  const BACKEND = 'backend'; ApplicationsEnum["BACKEND"] = BACKEND;
})(ApplicationsEnum || (ApplicationsEnum = {}));
